<template>
  <div>
      <el-form :model="detailForm" :rules="rules" ref="detailForm" label-width="100px" class="demo-detailForm">
        <el-form-item label="版本" prop="version">
            <el-input :disabled="isForbidden" v-model="detailForm.version"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select :disabled="isForbidden" v-model="detailForm.type" clearable placeholder="请选择类型" style="width:100%">
            <el-option :key="index" v-for="(item,index) in typeOptions" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用" prop="enable">
          <el-select :disabled="isForbidden" style="width:100%;" v-model="detailForm.enable" placeholder="请选择状态" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效时间" prop="effectiveDate">
            <el-date-picker
                :disabled="isForbidden"
                clearable
                style="width:100%;"
                v-model="detailForm.effectiveDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="失效时间" >
            <el-date-picker
                :disabled="isForbidden"
                clearable
                style="width:100%;"
                v-model="detailForm.expireDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
        </el-form-item> -->
      </el-form>
    <el-row type="flex" justify="center">
      <el-button v-if="!isForbidden" type="primary" size="small" @click="onSave('detailForm')">保存</el-button>
    </el-row>
  </div>
</template>
<script>
import apiService  from "@/api/AAA/index.js";

export default {
  props: ['formData'],
  data() {
    return {
      isForbidden:"",
      categoryList2: [],
      typeOptions:[],
      statusList: [],
      detailForm: {
       
      },
      rules: {
           version:[
            { required: true, message: '请输入版本', trigger: 'blur' }
          ],
          type:[{
              required: true, message: '请选择类型', trigger: 'change'
          }],
          enable:[
            { required: true, message: '请选择状态', trigger: 'change' }
          ],
          effectiveDate:[
            { required: true, message: '请输入生效时间', trigger: 'change' }
          ],
        }
    }
  },
  created(){
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    if(roles.indexOf('QSPI_AAA_ADMIN')!=-1||roles.indexOf('QSPI_AAA_OWNER')!=-1){
      this.isForbidden=false
    }else{
      this.isForbidden=true
    }
      this.getTypeList()
      this.detailForm=this.formData
  },
  watch: {
    formData: {
      handler(newV, oldV) {
        this.detailForm = newV
      },
      immediate: true
    }
  },
  methods: {
    onSave(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 是否新增  this.detailForm.ttQspiAppraiseTemplateId
            if(!this.detailForm.ttQspiAppraiseTemplateId){
              apiService.addTemInfo(this.detailForm).then((res)=>{
                if(res.code==200){
                  this.$message.success('保存成功')
                  this.$emit('close')
                }else{
                  this.$message.error(res.msg)
                }
              })
            }else{
              apiService.updataTemInfo(this.detailForm,this.detailForm.ttQspiAppraiseTemplateId).then((res)=>{
                if(res.code==200){
                  this.$message.success('保存成功')
                  this.$emit('close')
                }else{
                  this.$message.error(res.msg)
                }
              })
            }
            

            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    getTypeList(){
      apiService.getTypeList().then((res)=>{
        this.typeOptions=res.resultData
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>